// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { DismissIcon, Flex, Link, Tag, Typography } from '@iheartjane/reefer';

import type { ActiveFilters } from '@jane/search/types';

export interface FilterChipsProps {
  activeFilters: ActiveFilters[];
  onClearAll: () => void;
  onClearFilter: (filter: ActiveFilters) => void;
}

const ClearFilterContainer = styled(Flex)(({ theme }) => ({
  backgroundColor: theme.colors.grays.mid,
  borderRadius: 20,
}));

interface FilterChipProps {
  filter: ActiveFilters;
  onClearFilter: (filter: ActiveFilters) => void;
}

const FilterChip = ({ filter, onClearFilter }: FilterChipProps) => {
  const { label } = filter;

  return (
    <Tag
      background="grays-black"
      color="grays-white"
      endIcon={
        <ClearFilterContainer ml={8}>
          <DismissIcon
            altText={`Clear ${label} filter`}
            size="sm"
            m={4}
            onClick={() => {
              onClearFilter(filter);
            }}
          />
        </ClearFilterContainer>
      }
      label={label}
      mr={16}
      size="lg"
    />
  );
};

export const FilterChips = ({
  activeFilters,
  onClearAll,
  onClearFilter,
}: FilterChipsProps) => {
  if (activeFilters.length === 0) {
    return null;
  }

  return (
    <Flex alignItems="center" flexWrap="wrap">
      {activeFilters.map((filter) => (
        <FilterChip
          key={`${filter.key}-${filter.label}`}
          filter={filter}
          onClearFilter={onClearFilter}
        />
      ))}
      {!!activeFilters.length && (
        <Link
          ariaLabel="Clear all filters"
          color="grays-black"
          onClick={onClearAll}
        >
          <Typography>Clear all</Typography>
        </Link>
      )}
    </Flex>
  );
};
